var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttons" }, [
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.isDae || !_vm.isPrimeiroPasso) && _vm.showButtonVoltar,
                expression: "(isDae || !isPrimeiroPasso) && showButtonVoltar"
              }
            ],
            attrs: { type: "default", name: "voltar" },
            on: { click: _vm.voltarAba }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-chevron-left" }),
              _c("b", [_vm._v("  Voltar")])
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonCancelar && !_vm.isIntroPasso,
                expression: "showButtonCancelar && !isIntroPasso"
              }
            ],
            staticClass: "cancelarButton",
            attrs: { name: "cancelar" },
            on: { click: _vm.cancelar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-times" }),
              _c("b", [_vm._v("  " + _vm._s(_vm.cancelarLabel))])
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonAnaliseManual,
                expression: "showButtonAnaliseManual"
              }
            ],
            attrs: { name: "analiseManual" },
            on: { click: _vm.changeAnalise }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fad fa-exchange-alt" }),
              _c("b", [_vm._v("  " + _vm._s(_vm.labelButtonAnaliseManual))])
            ])
          ]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonSalvar,
                expression: "showButtonSalvar"
              }
            ],
            attrs: { type: "success", name: "salvar" },
            on: { click: _vm.salvar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fas fa-save" }),
              _c("b", [_vm._v("  Salvar")])
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonDownload,
                expression: "showButtonDownload"
              }
            ],
            attrs: { type: "default", name: "download" },
            on: { click: _vm.download }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("b", [_vm._v("Download PDF  ")]),
              _c("i", { staticClass: "fa fa-download" })
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isUltimoPasso && _vm.showButtonProximo,
                expression: "!isUltimoPasso && showButtonProximo"
              }
            ],
            attrs: {
              disabled: _vm.disabledButtonProximo,
              type: "default",
              name: "proximo"
            },
            on: { click: _vm.proximo }
          },
          [
            _c("div", { staticClass: "center" }, [
              _c("b", [_vm._v("Próximo  ")]),
              _c("i", { staticClass: "fas fa-chevron-right" })
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  (_vm.isUltimoPasso && _vm.showButtonFinalizar) ||
                  _vm.isDespacho,
                expression:
                  "(isUltimoPasso && showButtonFinalizar) || isDespacho"
              }
            ],
            attrs: { type: "primary", name: "finalizar" },
            on: { click: _vm.finalizar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fa fa-check" }),
              _c("b", [_vm._v("  " + _vm._s(_vm.finalizarLabel))])
            ])
          ]
        ),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showButtonEnviar,
                expression: "showButtonEnviar"
              }
            ],
            attrs: { type: "primary", name: "enviar" },
            on: { click: _vm.enviar }
          },
          [
            _c("span", { staticClass: "center" }, [
              _c("i", { staticClass: "fa fa-share-square" }),
              _c("b", [_vm._v("  Enviar")])
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58dc2429", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58dc2429","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppButtonsCadastro.vue
// module id = null
// module chunks = 